import { PageContainer, SmallPaddingCard, SignTitle } from '@/components'
import { useEffect } from 'react'
import styled from 'styled-components'
import { useState } from 'react'
import { EmailTemplate } from './email-template'
import { useCheditor } from '@/utils'
import { useDebounce } from 'ahooks'
import { PhishingTemplate } from './phishing-template'
import { AcessoryTemplate } from './accessory-template'
import { EducationTemplate } from '@/pages/phishing/template/education-template'
import { t } from '@/i18n'
const Template = () => {
  let [selectTab, setSelectTab] = useState<'1' | '2' | '3' | '4'>('1')
  const tabClickHandler = (key: '1' | '2' | '3' | '4') => () => {
    setSelectTab(key)
  }
  let [element, setElement] = useState<HTMLDivElement | null>(null)
  const { editor } = useCheditor({
    height: 270,
    initData: '',
    element,
    onChange: e => {},
  })
  return (
    <PageContainer>
      <TempContainer>
        <div style={{ display: 'none' }}>
          <div ref={setElement} />
        </div>
        <LeftCard>
          {/* <NavList template={template} inputValue={inputValue} conduction={conduction} /> */}
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
            <div className="header-table">
              <div
                className="tab-item"
                onClick={tabClickHandler('1')}
                style={
                  selectTab === '1' ? { backgroundColor: '#4238C9', color: '#fFF' } : undefined
                }
              >
                {t('邮件模板')}
              </div>
              <div
                className="tab-item"
                onClick={tabClickHandler('2')}
                style={
                  selectTab === '2' ? { backgroundColor: '#4238C9', color: '#fFF' } : undefined
                }
              >
                {t('钓鱼页模板')}
              </div>
              <div
                className="tab-item"
                onClick={tabClickHandler('3')}
                style={
                  selectTab === '3' ? { backgroundColor: '#4238C9', color: '#FFFFFF' } : undefined
                }
              >
                {t('附件模板')}
              </div>
              <div
                className="tab-item"
                onClick={tabClickHandler('4')}
                style={
                  selectTab === '4' ? { backgroundColor: '#4238C9', color: '#FFFFFF' } : undefined
                }
              >
                {t('安全教育模板')}
              </div>
            </div>
          </div>
          <div>
            {selectTab === '1' && <EmailTemplate />}

            {selectTab === '2' && <PhishingTemplate />}
            {selectTab === '3' && <AcessoryTemplate />}
            {selectTab === '4' && <EducationTemplate />}
          </div>
        </LeftCard>
      </TempContainer>
    </PageContainer>
  )
}

export default Template

const TempContainer = styled.div`
  /* width: 100%; */
  min-height: 100%;
  min-width: 1290px;
  width: 100%;
  display: flex;
`

const LeftCard = styled(SmallPaddingCard)`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  border-radius: 8px;

  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .ant-card-body {
    display: flex;
    flex-direction: column;
    padding: 20px 0;
  }
  .ant-btn {
    width: 120px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .ant-image-img {
      height: 100%;
    }
  }
  .w260 {
    width: 230px;
  }
  .ant-btn {
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-input {
    box-shadow: none;
  }
  .hZhPXh,
  .ant-tabs {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .ant-input-search
    > .ant-input-group
    > .ant-input-group-addon:last-child
    .ant-input-search-button {
    border-radius: 4px;
    width: 30px;
  }
  .ant-tabs-content-holder {
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;

    margin: auto;
    padding: 0 16px;
    top: 170px;
  }
  .header-table {
    max-width: 725px;
    display: flex;
    background-color: rgb(208 210 230 / 70%);
    border-radius: 8px;
    margin-bottom: 18px;
    height: 36px;
    .tab-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 160px;
      border-radius: 8px;
      font-weight: 600;
      color: #333333;
    }
  }
`
